import { fetchJsonResponse } from '@/ai/api'
import { buildDescriptionValidatorPrompt } from '@/ai/prompts'

export const validateWorkflowDescription = async ({ workflow, abortController }) => {
  if (!workflow || !workflow.aiVersion) {
    return null
  }

  const messages = buildDescriptionValidatorPrompt({ workflow })

  try {
    const response = await fetchJsonResponse({
      messages,
      aiVersion: workflow.aiVersion,
      signal: abortController?.signal
    })

    return response || null
  } catch (error) {
    return null
  }
}
